export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f85aadcb023eea4b922a2fe8d15ca9cb52712110c&name=fetchTypeahead!'